import { Question } from "../../interfaces/purchase-order.interface";
import { EntitiesQuestions } from "./entities.questions";
import { cloneDeep } from "lodash";

export class DisenrollQuestion {
  public static question_disenroll_endorsement: Question[] = [
    {
      type: "radio",
      question: "¿La fecha capturada coincide con la del documento?",
      formatted_question: "¿La fecha capturada <b>coincide</b> con la del documento?",
      control: "date_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "La fecha capturada no coincide con la del documento",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "select",
      question: "Selecciona a qué entidad pertenece el comprobante",
      control: "belong_city",
      options: cloneDeep(EntitiesQuestions.question_entities),
      page: 1,
    },
    {
      type: "radio",
      question: "¿La baja está pagada correctamente?",
      control: "enroll_payment",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Aclara la situación con la agencia o con la entidad gubernamental correspondiente y carga el documento que mejor se ajuste a la resolución obtenida.",
          },
        },
      ],
      page: 2,
    },
    {
      type: "textbox",
      question: "Número de indentificación vehicular",
      control: "niv",
      label: "NIV",
      page: 3,
    },
    {
      type: "radio",
      question: "¿El número de serie coincide con el mostrado en el comprobante?",
      control: "valid_niv",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El número de identificacion vehicular no coincide.",
          },
        },
      ],
      page: 3,
    },
    {
      type: "select",
      question: "Selecciona el número de placas:",
      control: "list_plates",
      options: [{ label: "No encontré la placa", value: { value: "No encontré la placa", incident: true } }],
      page: 3,
    },
  ];

  public static question_disenroll: Question[] = [
    {
      type: "radio",
      question: "¿La fecha capturada coincide con la del documento?",
      formatted_question: "¿La fecha capturada <b>coincide</b> con la del documento?",
      control: "date_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "La fecha capturada no coincide con la del documento",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "select",
      question: "Selecciona a qué entidad pertenece el comprobante",
      control: "belong_city",
      options: cloneDeep(EntitiesQuestions.question_entities),
      page: 1,
    },
    {
      type: "radio",
      question: "¿Necesitas el comprobante de pago?",
      control: "need_enroll_payment",
      options: [
        {
          label: "Sí",
          value: {
            value: "si",
            incident: true,
            incident_text: "Es necesario que adjunten un comprobante pago",
          },
        },
        { label: "No", value: { value: "no", incident: false } },
      ],
      page: 2,
    },
    {
      type: "textbox",
      question: "Número de indentificación vehicular",
      control: "niv",
      label: "NIV",
      page: 3,
    },
    {
      type: "radio",
      question: "¿El número de serie coincide con el mostrado en el comprobante?",
      control: "valid_niv",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El número de identificacion vehicular no coincide.",
          },
        },
      ],
      page: 3,
    },
    {
      type: "select",
      question: "Selecciona el número de placas:",
      control: "list_plates",
      options: [{ label: "No encontré la placa", value: { value: "No encontré la placa", incident: true } }],
      page: 3,
    },
  ];
}
